
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexF4f4lvsyx_6TMdmORWLEQxVxo22gtyPbkkYuoj5qgWkMeta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/company/qualifications/index.vue?macro=true";
import { default as indexsrayRIFjw9ggkz2Ow0CwGbHXnXcQJnNdSYMX_jEEi4IMeta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/articles/[category]/[id]/index.vue?macro=true";
import { default as indexEiASJIUlC_Ndgj_hFqwi9jTLqs5caaVIpdHm8b6I2GUMeta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/media/[category]/[id]/index.vue?macro=true";
import { default as indexZEEbBuSE05r384ULLCaL75gNbBV_PJInCjrBeyoQ_y0Meta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/articles/[category]/index.vue?macro=true";
import { default as index3dAl7La_jTQNR777EQSicCLeZU7KLthKdr0L1lVTnoEMeta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/mall/[id]/index.vue?macro=true";
import { default as indexh4RqBFIEDeouYNZTbNa9SKP65i95bS_jA1v5UydD5a8Meta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/media/[category]/index.vue?macro=true";
import { default as index0bVTjlQvLHPij0uFZxLMCgcmCdNFrbvr_Kpj6lvQQxcMeta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/mall/index.vue?macro=true";
import { default as indexM_0QMfFsxwAEUTxZ4d7bMF_7rHG_ek2uEczTVfIvyNcMeta } from "/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/index/index.vue?macro=true";
export default [
  {
    name: "company-profile",
    path: "/company/profile",
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/company/profile/index.vue")
  },
  {
    name: "company-qualifications",
    path: "/company/qualifications",
    meta: indexF4f4lvsyx_6TMdmORWLEQxVxo22gtyPbkkYuoj5qgWkMeta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/company/qualifications/index.vue")
  },
  {
    name: "company-strength",
    path: "/company/strength",
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/company/strength/index.vue")
  },
  {
    name: "articles-category-id",
    path: "/articles/:category()/:id()",
    meta: indexsrayRIFjw9ggkz2Ow0CwGbHXnXcQJnNdSYMX_jEEi4IMeta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/articles/[category]/[id]/index.vue")
  },
  {
    name: "media-category-id",
    path: "/media/:category()/:id()",
    meta: indexEiASJIUlC_Ndgj_hFqwi9jTLqs5caaVIpdHm8b6I2GUMeta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/media/[category]/[id]/index.vue")
  },
  {
    name: "articles-category",
    path: "/articles/:category()",
    meta: indexZEEbBuSE05r384ULLCaL75gNbBV_PJInCjrBeyoQ_y0Meta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/articles/[category]/index.vue")
  },
  {
    name: "mall-id",
    path: "/mall/:id()",
    meta: index3dAl7La_jTQNR777EQSicCLeZU7KLthKdr0L1lVTnoEMeta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/mall/[id]/index.vue")
  },
  {
    name: "media-category",
    path: "/media/:category()",
    meta: indexh4RqBFIEDeouYNZTbNa9SKP65i95bS_jA1v5UydD5a8Meta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/media/[category]/index.vue")
  },
  {
    name: "mall",
    path: "/mall",
    meta: index0bVTjlQvLHPij0uFZxLMCgcmCdNFrbvr_Kpj6lvQQxcMeta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/mall/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexM_0QMfFsxwAEUTxZ4d7bMF_7rHG_ek2uEczTVfIvyNcMeta || {},
    component: () => import("/www/xing-ke-homepage/engine/storage/app/private/site-static/.site-deploy-build.3252652/source/frontend/apps/site/app/pages/index/index.vue")
  }
]